export class MasterDataCommon {
public static assignmentFormErrors = {
'name': '',
};
public static assignmentFormValidationMessages = {
'name': {
'required': 'name is required.',
'minlength': 'first name is minlength 50.',
'maxlength': 'first name is maxlength 50',
},
};

public static taskFormErrors = {
'name': '',
'assignments':''
};

public static taskFormValidationMessages = {
'name': {
'required': 'name is required.',
'minlength': 'first name is minlength 50.',
'maxlength': 'first name is maxlength 50',
},
'assignments': {
'required': 'assignments is required.',
},
};

public static branchFormErrors = {
    "name": "",
    "contactNo": "",
    "address": "",
    "offDays":""
};

public static branchFormValidationMessages = {
'name': { 'required': 'name is required.'},
'contactNo': { 'required': 'contact no is required.' },
'address': { 'required': 'address is required.' },
'offDays': { 'required': 'off days are required.' },
};

public static financialYearFormErrors = {
    "name": "",
    "startDate": "",
    "endDate": "",

};

public static financialYearFormValidationMessages = {
'name': { 'required': 'name is required.'},
'startDate': { 'required': 'start date is required.' },
'endDate': { 'required': 'end date is required.' },
};


public static designationFormErrors = {
    "name": "",
    "roles": "",
};

public static designationFormValidationMessages = {
'name': { 'required': 'name is required.'},
'roles': { 'required': 'roles date is required.' },
};

public static clientFormErrors = {
    "address": "",
    "alias": "",
    "branch": "",
    "chargeableToClient": "",
    "ediaryStatus": "",
    "email": "",
    "gstNumber": "",
    "legalStatus": "",
    "name": "",
    "pan": "",
    "principalPlaceOfBusiness": "",
    "sector": "",
    "id":"",
    "distance":"",
    "amount":""
    // "partners": [
    //   {
    //     "assignments": [
    //       {
    //         "id": 0,
    //         "name": "string"
    //       }
    //     ],
    //     "id": 0
    //   }
    // ],
    // "clientLocations": [
    //     {
    //       "amount": 0,
    //       "distance": 0,
    //       "id": 0
    //     }
    //   ]

};

public static clientFormValidationMessages = {
"address": { 'required': 'mandatory field'},
"alias": { 'required': 'mandatory field'},
"branch": { 'required': 'mandatory field'},
"chargeableToClient":{ 'required': 'mandatory field'},
"ediaryStatus": { 'required': 'mandatory field'},
"email": { 'required': 'mandatory field'},
"gstNumber": { 'required': 'mandatory field'},
"legalStatus": { 'required': 'mandatory field'},
"name": { 'required': 'mandatory field'},
"pan": { 'required': 'mandatory field'},
"principalPlaceOfBusiness": { 'required': 'mandatory field'},
"sector": { 'required': 'mandatory field'},
"id":{ 'required': 'mandatory field'},
"distance":{ 'required': 'mandatory field'},
"amount":{ 'required': 'mandatory field'},
};

public static myDiariesStdReportFormErrors = {
    "fromDate": "",
    "toDate": "",
    "clients": "",
};
public static myDiariesStdReportFormValidationMessages = {
    'fromDate': { 'required': 'from date is required.' },
    'toDate': { 'required': 'to date is required.' },
    'clients': { 'required': 'to clients is required.' },
    };

    public static diaryDetailsFormErrors = {
       "empStatus":"",
       "employee":"",
        "fromDate": "",
        "toDate": "",
    };
    public static diaryDetailsFormValidationMessages = {
        'empStatus': { 'required': 'status is required.' },
        'employee': { 'required': 'name is required.' },
        'fromDate': { 'required': 'from date is required.' },
        'toDate': { 'required': 'to date is required.' },
        };

   public static empanlementReportFormErrors={
       "branchName":"",
       "empanlementRole":"",
       "currentDate":"",
   }
}


